import TabsPage from '../../pages/TabsPage'
import { retrunAssets } from '../../utils/getAssets'
import ApelSection from './apelSection'

const Apel = ({ apelAData, apelCData }) => {
  const title = apelAData?.title
  const bg =
    apelAData?.backgroundImage != null
      ? retrunAssets(apelAData?.backgroundImage[0]?.url)
      : ''
  const tabs = [
    {
      header: 'Apel A',
      content: <ApelSection data={apelAData} />
    },
    {
      header: 'Apel C',
      content: <ApelSection data={apelCData} />
    }
  ]
  return <TabsPage title={title} bg={bg} tabs={tabs} />
}

export default Apel
